const styles = {
  container: {
    position: "absolute",
    left: "0",
    top: "0",
    right: "0",
    bottom: "0",
    zIndex: 10000,
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "none",
    border: 0,
    // need pseudo-selector for chrome workaround with backdropFilter
    "&:before": {
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      zIndex: " -1",
      backgroundColor: "rgb(13 20 35 / 72%)",
      backdropFilter: "blur(5px)",
      "-webkit-backdrop-filter": "blur(5px)",
    },
    "@media (max-width: 1200px)": {
      backgroundColor: "rgb(13 20 35 / 72%)",
      backdropFilter: "none",
    },
  },
  inputContainer: {
    position: "relative",
    width: "640px",
    marginTop: "100px",
    "@media (max-width: 1200px)": {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      width: "90%",
      marginTop: "35px",
    },
  },
  searchIcon: {
    position: "absolute",
    top: "58%",
    left: "10px",
    transform: "translateY(-50%) scale(0.85)",
    filter:
      "invert(53%) sepia(6%) saturate(2488%) hue-rotate(188deg) brightness(83%) contrast(93%)",
    cursor: "pointer",
  },
  searchBar: {
    display: "flex",
    alignItems: "center",
    background: "white",
    height: "50px",
    width: "100%",
    padding: "0 50px 0 50px",
    fontFamily: `CircularStd, Circular Std Book`,
    border: "1px solid rgba(99, 115, 164, 0.2)",
    borderRadius: "5px",
    fontSize: "18px",
    lineHeight: "24px",
    "&::placeholder": {
      color: "rgba(99, 115, 164, 1)",
    },
    "&:focus": {
      outline: "none",
    },
    "@media (max-width: 1200px)": {
      height: "45px",
      width: "100%",
      padding: "0 30px 0 45px",
      fontSize: "14px",
    },
  },
  cancelText: {
    display: "none", // hidden by default
    backgroundColor: "transparent",
    border: 0,
    height: "45px",
    "@media (max-width: 1200px)": {
      fontFamily: `CircularStd, Circular Std Book`,
      fontSize: "14px",
      color: "#FFF",
      display: "inline",
    },
  },
  closeIcon: {
    position: "absolute",
    right: "-90px",
    top: "12px",
    backgroundColor: "transparent",
    border: 0,
    borderLeft: "1px solid #6374a4",
    "@media (max-width: 1200px)": {
      top: "inherit",
      right: "70px",
    },
  },
  closeModalIcon: {
    top: "20px",
    position: "absolute",
    right: "20px",
    zIndex: 1000000,
    color: "white",
    cursor: "pointer",
    background: "white",
    border: "1px solid rgba(99, 115, 164, 0.2)",
    paddingTop: "5px",
    borderRadius: "5px",
    "@media (max-width: 1200px)": {
      display: "none",
    },
  },
  cellContainer: {
    backgroundColor: "transparent",
    border: "none",
    width: "324px",
    "@media screen and (max-width : 1199px)": {
      width: "95%",
    },
  },
  img: {
    height: "186px",
    width: "100%",
    borderRadius: "5px",
    cursor: "pointer",
    position: "relative",
  },
  instagram: {
    height: "186px",
    width: "100%",
    borderRadius: "5px",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
  },
  iframe: {
    pointerEvents: "none",
    position: "absolute",
    height: "140%",
    width: "100%",
    top: "-70px",
  },
  campusreel: {
    height: "100%",
    width: "100%",
    borderRadius: "5px",
    cursor: "pointer",
    position: "relative",
    overflow: "hidden",
    pointerEvents: "none",
  },
  title: {
    color: "rgba(5, 29, 57, 1)",
    fontFamily: `CircularStd, Circular Std Book`,
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "20px",
    padding: "10px 0",
    textWrap: "wrap",
    textAlign: "left",
    "@media (max-width: 1200px)": {
      color: "#fff",
    },
  },
  category: {
    color: "rgba(99, 115, 164, 1)",
    fontSize: "12px",
    fontWeight: 450,
    lineHeight: "18px",
    textWrap: "wrap",
  },
  thumbnailIcon: {
    position: "absolute",
    right: "22px",
    bottom: "15px",
  },
  campusReelIcon: {
    width: "32px",
    height: "32px",
    float: "right",
    borderRadius: "16px",
    background: "rgba(190,10,255,0.70)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
  },
};

export default styles;
